<template>
  <div class="page-deliver-todo">
    <div class="pg-breadcrumb">
      <div class="breadcrumb-item em">報表統計</div>
      <div class="breadcrumb-item">本地退報表</div>
    </div>
    <div class="card-block">
      <Form inline class="pg-form-inline">
	      <FormItem>
            <Input size="small" placeholder="RSAM退货码" clearable v-model="form.barcode"
                   @keyup.enter.native="handleSearch"></Input>
        </FormItem>
        <FormItem>
          <DatePicker
	          class="no-suffix"
	          type="date"
	          size="small"
	          clearable
	          placeholder="開始日期"
	          v-model="form.start_time"
	          value-format="yyyy-MM-dd"
	          style="width: 100%"
          ></DatePicker>
        </FormItem>
        <FormItem>-</FormItem>
        <FormItem>
          <DatePicker
	          class="no-suffix"
	          type="date"
	          size="small"
	          clearable
	          placeholder="結束日期"
	          v-model="form.end_time"
	          value-format="yyyy-MM-dd"
	          style="width: 100%"
          ></DatePicker>
        </FormItem>
        <FormItem>
          <div class="pg-btn-wrap">
            <div class="pg-btn style1" @click="handleSearch">搜索</div>
            <div class="pg-btn style2" @click="handleExport_zh">
              導出excel-zh
            </div>
	          <div class="pg-btn style2" @click="handleExport_zh2">
              導出excel-zh(简易)
            </div>
          </div>
        </FormItem>
      </Form>
    </div>

    <div class="card-block pd-bt">
      <Spin fix class="pg-sub-loading" v-if="isSubmiting">
        <Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
        <div class="loading-text">Loading</div>
      </Spin>

      <Table
	      size="small"
	      border
	      no-data-text="暫無數據"
	      :columns="table.column"
	      :data="table.data"
      >
	      <template  slot-scope="{ row, index }" slot="images">
		      <div style="display: flex;flex-wrap: wrap;">
			      <div  v-for="(img,index) in row.images" :key="index">
				      <!--<img style="width: 50px;height: 50px;object-fit: contain;" :src="img.photo_url" @click="viewImage=img.photo_url;showImage=true;"/>-->
				      <el-image
					      style="width: 50px; height: 50px"
					      @click="handlesrcList(img.photo_url)"
					      :src="img.photo_url"
					      :preview-src-list="srcList">
             </el-image>
            </div>
		      </div>
        </template>
      </Table>

      <div class="pg-pagger">
        <Row>
          <Col span="11" class="pagger-left">
            <div class="pagger-total">總共{{ totalCount }}條記錄</div>
          </Col>
          <Col span="13" class="pagger-right">
            <!-- v-if="totalCount > curPageSize" -->
            <div>
              <div class="pagger-sizer">
                <span>每頁</span>
                <Select
	                v-model="curPageSize"
	                size="small"
	                placeholder="數量"
	                @on-change="handlePageSizeChange"
                >
                  <Option :value="10">10</Option>
                  <Option :value="20">20</Option>
                  <Option :value="30">30</Option>
                  <Option :value="40">40</Option>
                  <Option :value="50">50</Option>
                </Select>
              </div>

              <div class="pagger-elevator">
                <span>跳轉</span>
                <Input
	                size="small"
	                v-model="pageInput"
	                @on-keyup="handlePageInput"
	                @on-enter="handlePageEnter"
                />
              </div>

              <Page
	              size="small"
	              :current="pageIndex"
	              :page-size="curPageSize"
	              :total="totalCount"
	              @on-change="handlePageChange"
              >
              </Page>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import xlsx from "json-as-xlsx";
import dayjs from "dayjs";
import {uniqBy} from "lodash";

export default {
	data() {
		return {
			pageIndex: 1, //页码
			curPageSize: 10, //一页数量
			totalCount: 1, //总条数
			pageInput: "", //输入的页码
			form: {
				start_time: "",
				end_time: "",
				barcode: ""
				// end_time: this.getselectdate(),
			},
			isSubmiting: false,
			isLoadExcel: false,
			table: {
				column: [
					{
						title: "rsam碼",
						key: "barcode",
						align: "center",
						sortable: true,
						minWidth: 100,
					},
					{
						title: "價格",
						key: "price",
						align: "center",
						sortable: true,
						minWidth: 100,
					},
					{
						title: "操作人",
						key: "realname",
						align: "center",
						sortable: true,
						minWidth: 100,
					},
					{
						title: "操作人賬號",
						key: "phone",
						align: "center",
						sortable: true,
						minWidth: 100,
					},
					{
						title: "公司",
						key: "parentName",
						align: "center",
						sortable: true,
						minWidth: 100,
					},
					{
						title: "門店",
						key: "ReceivingName",
						align: "center",
						sortable: true,
						minWidth: 100,
					},
					{
						title: "操作時間",
						key: "time",
						align: "center",
						sortable: true,
						minWidth: 100,
					}, {
						title: "圖片",
						key: "images",
						slot: 'images',
						align: "center",
						sortable: true,
						width: 200,
					},
				],
				data: [],
			},
			srcList: []
		};
	},
	methods: {
		handlesrcList(imgobj) {
			this.srcList = [];
			this.srcList.push(imgobj);
		},
		validateDateRange(startDate, endDate) {
			const start = new Date(startDate);
			const end = new Date(endDate);
			
			if (isNaN(start) || isNaN(end)) {
				console.log("无效的日期格式");
				return false;
			}
			
			const timeDifference = end - start;
			const dayDifference = timeDifference / (1000 * 3600 * 24);
			
			if (dayDifference < 0) {
				console.log("结束时间必须晚于开始时间");
				return false;
			} else if (dayDifference > 16) {
				console.log("选择的时间范围不能超过 15 天");
				return false;
			} else {
				console.log("选择的时间范围有效");
				return true;
			}
		},
		getselectdate() {
			var date = new Date();
			var seperator1 = "-";
			var year = date.getFullYear();
			var month = date.getMonth() + 1;
			var strDate = date.getDate();
			
			if (month >= 1 && month <= 9) {
				month = "0" + month;
			}
			if (strDate >= 0 && strDate <= 9) {
				strDate = "0" + strDate;
			}
			var currentdate = year + "-" + month + "-" + strDate;
			return currentdate;
		},
		formatDate(datetime) {
			if (!datetime) return "";
			
			let dateTime = new Date(datetime);
			let year = dateTime.getFullYear();
			let month = dateTime.getMonth() + 1;
			let date = dateTime.getDate();
			let hour = dateTime.getHours();
			let minute = dateTime.getMinutes();
			let second = dateTime.getSeconds();
			let milliseconds = dateTime.getMilliseconds();
			return `${this.formatNum(year)}-${this.formatNum(month)}-${this.formatNum(
				date
			)} ${this.formatNum(hour)}:${this.formatNum(second)}:${this.formatNum(
				milliseconds
			)}`;
		},
		formatNum(num) {
			return num < 10 ? "0" + num : num;
		},
		handleExport_zh() {
			if (this.isLoadExcel) {
				return this.$Utils.showTipInfo("正在下載報表，請稍等");
			}
			console.log("导出");
			let form = this.form;
			if (!form.start_time || !form.end_time) {
				return this.$Utils.showTipInfo("請選擇導出時間");
			}
			if (this.validateDateRange(form.start_time, form.end_time) === false) {
				return this.$Utils.showTipInfo("數據過多！請選擇15天左右的時間範圍");
			}
			this.isSubmiting = true;
			this.isLoadExcel = true;
			console.log(form.start_time, form.end_time);
			this.$Rq
				.requestAuth({
					url: this.$Api.returnedItems,
					method: "get",
					data: {
						limit: 999999,
						page: 1,
						time_start: this.$Utils.formatDate(form.start_time),
						time_end: dayjs(form.end_time).add(1, "day").format("YYYY-MM-DD"),
						barcode: "",
					},
				})
				.then((res) => {
					console.log(res);
					
					if (res.status) {
						const data1 = res.list.data.map((item) => {
							item.price = parseFloat(item.price) || 0;
							item.barcode = item.barcode ? item.barcode.toUpperCase() : '---'
							return item;
						})
						const data = uniqBy(data1, 'barcode');
						
						const table = [
							{
								sheet: "本地退報表",
								columns: [
									{label: "創建時間", value: "time"},
									{label: "公司", value: "parentName"},
									{label: "門店", value: "ReceivingName"},
									{label: "退貨碼", value: "barcode"},
									{label: "退貨價值", value: "price"},
								],
								content: data,
							},
						];
						xlsx(table, {
							fileName: "本地退報表",
							extraLength: 3,
							writeMode: "writeFile",
							writeOptions: {},
							RTL: false,
						});
						
						this.isSubmiting = false;
						this.isLoadExcel = false;
					} else {
						this.$Utils.showTipInfo(res);
						this.isSubmiting = false;
						this.isLoadExcel = false;
					}
				})
				.catch((e) => {
					console.log(e);
					this.$Utils.showTipInfo("暫無數據或導出失敗");
					this.isSubmiting = false;
					this.isLoadExcel = false;
				});
		},
		handleExport_zh2() {
			if (this.isLoadExcel) {
				return this.$Utils.showTipInfo("正在下載報表，請稍等");
			}
			console.log("导出");
			let form = this.form;
			if (!form.start_time || !form.end_time) {
				return this.$Utils.showTipInfo("請選擇導出時間");
			}
			if (this.validateDateRange(form.start_time, form.end_time) === false) {
				return this.$Utils.showTipInfo("數據過多！請選擇15天左右的時間範圍");
			}
			this.isSubmiting = true;
			this.isLoadExcel = true;
			console.log(form.start_time, form.end_time);
			this.$Rq
				.requestAuth({
					url: this.$Api.returnedItems,
					method: "get",
					data: {
						limit: 999999,
						page: 1,
						time_start: this.$Utils.formatDate(form.start_time),
						time_end: dayjs(form.end_time).add(1, "day").format("YYYY-MM-DD"),
						barcode: "",
					},
				})
				.then((res) => {
					console.log(res);
					
					if (res.status) {
						const data1 = res.list.data.map((item) => {
							item.price = parseFloat(item.price) || 0;
							item.barcode = item.barcode ? item.barcode.toUpperCase() : '---'
							return item;
						})
						const data = uniqBy(data1, 'barcode');
						
						const table = [
							{
								sheet: "本地退報表",
								columns: [
									{label: "創建時間", value: "time"},
									{label: "退貨碼", value: "barcode"},
								],
								content: data,
							},
						];
						xlsx(table, {
							fileName: "本地退報表",
							extraLength: 3,
							writeMode: "writeFile",
							writeOptions: {},
							RTL: false,
						});
						
						this.isSubmiting = false;
						this.isLoadExcel = false;
					} else {
						this.$Utils.showTipInfo(res);
						this.isSubmiting = false;
						this.isLoadExcel = false;
					}
				})
				.catch((e) => {
					console.log(e);
					this.$Utils.showTipInfo("暫無數據或導出失敗");
					this.isSubmiting = false;
					this.isLoadExcel = false;
				});
		},
		getList() {
			let form = this.form;
			this.isSubmiting = true;
			this.$Rq
				.requestAuth({
					url: this.$Api.returnedItems,
					method: "get",
					data: {
						limit: this.curPageSize,
						page: this.pageIndex,
						time_start: form.start_time ? this.$Utils.formatDate(form.start_time) : '',
						time_end: form.end_time ? dayjs(form.end_time).add(1, "day").format("YYYY-MM-DD") : '',
						barcode: form.barcode,
					},
				})
				.then((res) => {
					this.isSubmiting = false;
					if (res.status) {
						let resData = res.list.data.map((it) => {
							it.realname = it.admin_info[0]?.realname || it.phone;
							return it;
						});
						this.totalCount = res.list.total;
						this.table.data = resData;
					}
				})
				.catch((err) => {
					// this.isLoading = false;
					this.isSubmiting = false;
				});
		},
		
		handleSearch() {
			let different_time = this.$Utils.differenttDate(
				this.form.start_time,
				this.form.end_time
			);
			
			/*else if (this.form.end_time < this.form.start_time ) {
			 this.$Utils.showTipInfo('起始時間不能大於結束時間');
			 return;
			 } else if (different_time > 7){
			 this.$Utils.showTipInfo('起始時間加結束時間大過7日');
			 return;
			 }*/
			this.pageIndex = 1;
			this.getList();
		},
		
		//pager
		handlePageSizeChange(value) {
			this.pageIndex = 1;
			this.getList();
		},
		
		handlePageInput() {
			let value = ("" + this.pageInput).replace(/\D/g, "");
			let pageCount = Math.ceil(this.totalCount / this.curPageSize);
			if (value > pageCount) {
				value = pageCount;
			}
			this.pageInput = value;
		},
		handlePageEnter() {
			if (this.pageInput == "" || this.pageInput == this.pageIndex) return;
			if (this.pageInput == 0) {
				this.pageInput = 1;
			}
			this.pageInput = parseInt(this.pageInput);
			this.pageIndex = this.pageInput;
			this.getList();
		},
		
		handlePageChange(value) {
			this.pageIndex = value;
			this.getList();
		},
	},
};
</script>

<style lang="scss" scoped>
@import "forecast.scss";
</style>
